import { HubPage } from '@/components/admin/HubPage';
import { PorAgendarTab, RecuperarTab, FollowupSettingsTab } from '@/components/admin/FollowupLists';
import PainelInicialPage from '@/pages/admin/PainelInicialPage';
import AdminDashboardPage from '@/pages/admin/AdminDashboardPage';
import MensagensAdminPage from '@/pages/admin/MensagensAdminPage';
import AdminFeedbackPage from '@/pages/admin/AdminFeedbackPage';
import PreConsultaPage from '@/pages/admin/PreConsultaPage';
import PreConsultationAuditPage from '@/pages/admin/PreConsultationAuditPage';
import AnamneseEditorPage from '@/pages/admin/AnamneseEditorPage';
import AdminOnboardingPage from '@/pages/admin/AdminOnboardingPage';
import AdminFormsPage from '@/pages/admin/AdminFormsPage';
import ReceitasPage from '@/pages/ReceitasPage';
import AdminRecipesPage from '@/pages/admin/AdminRecipesPage';
import BabyRecipeBankPage from '@/pages/admin/BabyRecipeBankPage';
import AlimentosPage from '@/pages/AlimentosPage';
import BabyFoodsPage from '@/pages/admin/BabyFoodsPage';
import EquivalentesPage from '@/pages/admin/EquivalentesPage';
import TabelaINSAPage from '@/pages/admin/TabelaINSAPage';
import SuplementacaoTemplatesPage from '@/pages/admin/SuplementacaoTemplatesPage';
import SupplementLibraryPage from '@/pages/admin/SupplementLibraryPage';
import AdminConteudosPage from '@/pages/admin/AdminConteudosPage';
import ModelosPage from '@/pages/admin/ModelosPage';
import GuidesEditorPage from '@/pages/admin/GuidesEditorPage';
import CalendarioEditorialPage from '@/pages/admin/CalendarioEditorialPage';
import SessoesGratuitasPage from '@/pages/admin/SessoesGratuitasPage';
import ContentCasesPage from '@/pages/admin/ContentCasesPage';
import CeoDashboardPage from '@/pages/admin/CeoDashboardPage';
import MetricasHubPage from '@/pages/admin/MetricasHubPage';
import FinanceiroHubPage from '@/pages/admin/FinanceiroHubPage';
import NutriChequesPage from '@/pages/admin/NutriCheques/NutriChequesPage';
import MeusPagamentosPage from '@/pages/admin/MeusPagamentosPage';
import NotificacoesPage from '@/pages/admin/NotificacoesPage';
import WhatsAppPage from '@/pages/admin/WhatsAppPage';
import EmailsPage from '@/pages/admin/EmailsPage';
import AdminSchedulePage from '@/pages/admin/AdminSchedulePage';
import DisponibilidadePage from '@/pages/admin/DisponibilidadePage';
import PatientCategoriesPage from '@/pages/admin/PatientCategoriesPage';
import TaskSettingsPage from '@/pages/admin/TaskSettingsPage';
import PersonalFinanceHubPage from '@/pages/admin/PersonalFinance/PersonalFinanceHubPage';
import ImportPacientesPage from '@/pages/admin/ImportPacientesPage';
import AdminBackupPage from '@/pages/admin/AdminBackupPage';
import ApagadosRecentementePage from '@/pages/admin/ApagadosRecentementePage';
import { GuideTemplateTab } from '@/components/admin/GuiaOrientacoes';
import PaymentMethodsTab from '@/components/admin/PaymentMethodsTab';
import GcalDuplicatesTab from '@/components/admin/GcalDuplicatesTab';
import AccessLogsPage from '@/pages/admin/AccessLogsPage';
import DashboardTextsPage from '@/pages/admin/DashboardTextsPage';
import InstallmentsToConfigurePage from '@/pages/admin/InstallmentsToConfigurePage';

const hub = (id, defaultTab, tabs) => () => <HubPage id={id} defaultTab={defaultTab} tabs={tabs} />;

export const InicioHub = hub('inicio', 'painel', [
  { key: 'painel', label: 'Painel inicial', component: PainelInicialPage },
  { key: 'hoje', label: 'Hoje', component: AdminDashboardPage },
  { key: 'por-agendar', label: 'Por agendar', component: PorAgendarTab },
  { key: 'recuperar', label: 'Recuperar', component: RecuperarTab },
]);
export const MensagensHub = hub('mensagens', 'mensagens', [
  { key: 'mensagens', label: 'Mensagens', component: MensagensAdminPage },
  { key: 'feedback', label: 'Feedback Consultas', component: AdminFeedbackPage },
]);
export const QuestionariosHub = hub('questionarios', 'pre-consulta', [
  { key: 'pre-consulta', label: 'Questionários Pré-Consulta', component: PreConsultaPage },
  { key: 'auditoria', label: 'Auditoria Pré-Consulta', component: PreConsultationAuditPage },
]);
export const FormulariosHub = hub('formularios', 'formularios', [
  { key: 'anamnese', label: 'Anamnese', component: AnamneseEditorPage },
  { key: 'onboarding', label: 'Onboarding', component: AdminOnboardingPage },
  { key: 'formularios', label: 'Formulários', component: AdminFormsPage },
]);
export const ReceitasHub = hub('receitas', 'receitas', [
  { key: 'receitas', label: 'Receitas', component: ReceitasPage },
  { key: 'comunidade', label: 'Receitas Comunidade', component: AdminRecipesPage },
  { key: 'bebe', label: 'Receitas de Bebé', component: BabyRecipeBankPage },
]);
export const AlimentosHub = hub('alimentos', 'alimentos', [
  { key: 'alimentos', label: 'Alimentos', component: AlimentosPage },
  { key: 'tabela-insa', label: 'Tabela INSA', component: TabelaINSAPage },
  { key: 'bebes', label: 'Alimentos Bebés', component: BabyFoodsPage },
  { key: 'equivalentes', label: 'Equivalentes', component: EquivalentesPage },
]);
export const SuplementacaoHub = hub('suplementacao', 'suplementacao', [
  { key: 'suplementacao', label: 'Suplementação', component: SuplementacaoTemplatesPage },
  { key: 'biblioteca', label: 'Biblioteca de Suplementos', component: SupplementLibraryPage },
]);
export const MateriaisHub = hub('materiais', 'conteudos', [
  { key: 'conteudos', label: 'Conteúdos', component: AdminConteudosPage },
  { key: 'modelos', label: 'Modelos', component: ModelosPage },
  { key: 'guias', label: 'Guias de Utilização', component: GuidesEditorPage },
]);
export const MarketingHub = hub('marketing', 'calendario', [
  { key: 'calendario', label: 'Calendário Editorial', component: CalendarioEditorialPage },
  { key: 'sessoes', label: 'Sessões Gratuitas', component: SessoesGratuitasPage },
  { key: 'casos', label: 'Casos para Conteúdo', component: ContentCasesPage },
]);
export const MetricasHub = hub('metricas', 'ceo', [
  { key: 'ceo', label: 'Dashboard CEO', component: CeoDashboardPage },
  { key: 'metricas', label: 'Métricas', component: MetricasHubPage, hashDefault: true },
]);
export const FinanceiroHub = hub('financeiro', 'financeiro', [
  { key: 'financeiro', label: 'Financeiro', component: FinanceiroHubPage, adminOnly: true, hashDefault: true },
  { key: 'cheques', label: 'Cheques Nutricionista', component: NutriChequesPage, adminOnly: true },
  { key: 'meus-pagamentos', label: 'Os meus pagamentos', component: MeusPagamentosPage },
  { key: 'prestacoes-por-configurar', label: 'Prestações por configurar', component: InstallmentsToConfigurePage, nonAdminOnly: true },
]);
const NotifTab = (forceTab) => () => <NotificacoesPage forceTab={forceTab} />;
const EmailTab = (forceTab) => () => <EmailsPage forceTab={forceTab} />;
export const ComunicacoesHub = hub('comunicacoes', 'notificacoes', [
  { key: 'notificacoes', label: 'Templates', component: NotifTab('templates') },
  { key: 'todas', label: 'Notificações', component: NotifTab('todas') },
  { key: 'datas', label: 'Datas de referência', component: NotifTab('datas') },
  { key: 'modelos', label: 'Modelos de email', component: NotifTab('modelos') },
  { key: 'sistema', label: 'Sistema', component: NotifTab('sistema') },
  { key: 'whatsapp', label: 'WhatsApp', component: WhatsAppPage },
  { key: 'emails', label: 'Registo de emails', component: EmailTab('emails') },
  { key: 'onboarding', label: 'Onboarding', component: EmailTab('onboarding') },
  { key: 'textos-dashboard', label: 'Textos do Dashboard', component: DashboardTextsPage },
]);
export const ConfiguracoesHub = hub('configuracoes', 'configuracoes', [
  { key: 'configuracoes', label: 'Configurações', component: AdminSchedulePage },
  { key: 'disponibilidade', label: 'Disponibilidade', component: DisponibilidadePage },
  { key: 'categorias', label: 'Categorias Pacientes', component: PatientCategoriesPage },
  { key: 'tarefas-automaticas', label: 'Tarefas Automáticas', component: TaskSettingsPage },
  { key: 'acompanhamento', label: 'Acompanhamento', component: FollowupSettingsTab },
  { key: 'guia-modelo', label: 'Guia infantil', component: GuideTemplateTab, adminOnly: true },
  { key: 'pagamentos', label: 'Pagamentos', component: PaymentMethodsTab, adminOnly: true },
  { key: 'prestacoes-por-configurar', label: 'Prestações por configurar', component: InstallmentsToConfigurePage },
  { key: 'google-calendar', label: 'Google Calendar', component: GcalDuplicatesTab, adminOnly: true },
  { key: 'financas-pessoais', label: 'Finanças Pessoais', component: PersonalFinanceHubPage, ownerOnly: true },
]);
export const DadosHub = hub('dados', 'importar', [
  { key: 'importar', label: 'Importar Pacientes', component: ImportPacientesPage },
  { key: 'backups', label: 'Backups', component: AdminBackupPage },
  { key: 'apagados', label: 'Apagados recentemente', component: ApagadosRecentementePage },
  { key: 'acessos', label: 'Registo de acessos', component: AccessLogsPage, adminOnly: true },
]);
